import { render } from "./DocumentDetail.vue?vue&type=template&id=37824f8c&scoped=true&ts=true"
import script from "./DocumentDetail.vue?vue&type=script&lang=ts"
export * from "./DocumentDetail.vue?vue&type=script&lang=ts"

import "./DocumentDetail.vue?vue&type=style&index=0&id=37824f8c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37824f8c"]])

export default __exports__